import { Tag } from "components/DesignSystem/Tag/Tag";
import { TICKET_PAID, TICKET_PAYMENT } from "constants/ticket";

export type PricedTicketCardStatusType =
  | typeof TICKET_PAYMENT
  | typeof TICKET_PAID;

export const PricedTicketStatus = ({
  status,
}: {
  status: PricedTicketCardStatusType;
}) => {
  switch (status) {
    case TICKET_PAYMENT:
      return (
        <Tag rounded tagType="red" size="small">
          Payment pending
        </Tag>
      );

    case TICKET_PAID:
      return (
        <Tag rounded tagType="green" size="small">
          Paid
        </Tag>
      );

    default: {
      return <></>;
    }
  }
};
